<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules"  label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 报销审批</template>
                            <Row :gutter="32">
                                <Col span="24">
                                    <FormItem label="审批" prop="status" :rules="[{required: true, type:'number', message: '请选择审批结果', trigger: 'change',  transform(value) { return parseInt(value)}}]">
                                        <RadioGroup v-model="Forms.status" type="button" button-style="solid">
                                            <Radio :label="5">通过审批</Radio>
                                            <Radio :label="4">驳回申请</Radio>
                                        </RadioGroup>
                                    </FormItem>
                                </Col>
                                <Col span="24" v-if="Forms.status === 4">
                                    <FormItem  label="驳回原因" prop="reject_remark" :rules="[{required: true, message: '请输入驳回原因', trigger: 'blur'}]">
                                        <Input v-model="Forms.reject_remark" type="textarea" :rows="4" clearable placeholder="驳回原因"  />
                                    </FormItem>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 报销信息</template>
                            <DescriptionList class="show-description-title" title="" :col="3"  layout="vertical">
                                <Description term="报销金额：">
                                    <Tag color="blue">{{detail.money}}</Tag>
                                </Description>
                                <Description term="报销编号：">
                                    {{detail.sn}}
                                </Description>
                                <Description term="报销模式：">
                                    {{detail.mode_name}}
                                </Description>
                                <Description v-if="detail.mode_id === 2" term="报销项目：">
                                    {{detail.project_name}}
                                </Description>
                                <Description v-if="detail.mode_id === 3" term="零星项目：">
                                    {{detail.small_project_name ?? '-'}}
                                </Description>
                                <Description v-if="detail.mode_id === 3" term="维保记录：">
                                    {{detail.maintain_title ?? '-'}}
                                </Description>
                                <Description term="报销类型：">
                                    {{detail.type_name}}
                                </Description>
                                <Description term="收款账号：">
                                    {{detail.account ?? '-'}}
                                </Description>
                                <Description term="申请人：">
                                    {{detail.apply_name}}
                                </Description>
                                <Description term="申请时间：">
                                    {{detail.apply_time}}
                                </Description>
                            </DescriptionList>
                          <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical">
                            <Description term="报销凭证">
                              <div class="uploads">
                                <div class="upload-images" v-for="(item,index) in detail.image" :key="index" @click.stop="">
                                  <img :src="site_url + item">
                                  <div class="show" @click.stop="PhotoView(site_url + item)">预览</div>
                                </div>
                              </div>
                            </Description>
                          </DescriptionList>
                            <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical" v-if="detail.remark">
                                <Description term="备注信息：">
                                    {{detail.remark}}
                                </Description>
                            </DescriptionList>
                        </Card>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认审批</Button>
            </div>

            <!-- 预览图片 -->
            <Modal
                v-model="is_view_box"
                title="预览"
                :width="840"
                :mask-closable="true"
                :footer-hide="true"
                @on-cancel="PhotoViewClose()">
                <div class="flex-image-box">
                    <img :src="view_url" class="flex-image-box-show">
                </div>
            </Modal>
        </div>
    </Drawer>
</template>

<script>

import {examineExpense, getExpenseDetail} from "@/apis/expense";

export default {
    name: 'IncomeExamine',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '报销审批',
            isBox : false,
            detail: [],
            site_url : this.$siteApi,
            is_view_box : false,
            view_url : '',
            Forms : {
                id: '',
                status: 5,
                reject_remark: ''
            },
            Rules : {

            }
        }
    },
    methods: {
      FileDownload(url){
        let that = this;
        if(url){
          //下载文件
          const fileUrl = that.site_url + url; // 文件的URL地址
          const parts = fileUrl.split('/');
          const fileName = parts[parts.length - 1];
          const link = document.createElement('a');
          link.href = fileUrl;
          link.target = '_blank';
          link.setAttribute('download', fileName);
          link.click();
        }else{
          that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
        }
      },
        /**
         功能：图片预览
         time: 2025-17-15 10:17:00
         **/
        PhotoView(url){
            if(url){
                this.view_url = url;
                this.is_view_box = true;
            }
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        PhotoViewClose(){
            this.is_view_box = false;
            this.view_url = '';
        },

        /**
         功能：
         time: 2025/12/17 16:04
         **/
        GetDetail(id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getExpenseDetail(id).then(e => {
                that.detail = e.data;
                that.title = e.data.apply_name + ' 的报销审批'
            })
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        show(id){
            this.isBox = true;
            if(id){
                this.Forms.id = id;
                this.GetDetail(id);
            }
        },
        /**
         功能：
         time: 2025/12/26 16:14
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    examineExpense(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025/12/20 11:54
         **/
        FormReset(){
            this.isBox = false;
            this.title = '报销审批';
            this.$refs['Forms'].resetFields();
            this.Forms = {
                id: '',
                status: 5,
                reject_remark: ''
            };
            this.detail = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
